import { EnvironmentUtils, UserUtils } from 'utils'
import { MarketingMode } from 'modules/simulatorTrainings/common/components'

const MarketingModeLayer: React.FC = ({ children }) => {
  const { customer } = UserUtils.getUserLoginParams()
  const { isMarketingModeEnabled } = EnvironmentUtils.getPermissions('simulatorTraining')

  if (isMarketingModeEnabled) return <MarketingMode customerName={customer} />

  return <>{children}</>
}

export default MarketingModeLayer
